import React, { useCallback, useMemo, useRef, useState } from 'react'
import { HexColorPicker } from 'react-colorful'

import { useOnClickOutside } from 'usehooks-ts'

const ColorSwatchPicker = ({ color, onChange }) => {
  const popoverRef = useRef()
  const [isOpen, toggle] = useState(false)

  const close = useCallback(() => toggle(false), [])
  const open = useCallback(() => toggle(true), [])
  const colorStyle = useMemo(() => ({ backgroundColor: color }), [color])
  useOnClickOutside(popoverRef, close)

  return (
    <div className="k-picker relative">
      <div
        className="k-swatch cursor-pointer rounded-md ring-offset-2 ring-2 h-10 w-10"
        style={colorStyle}
        onClick={open}
      />

      {isOpen && (
        <div
          className="k-popover absolute right-0 border border-gray-500 rounded-lg shadow-xl"
          ref={popoverRef}
          style={{ top: 'calc(100% + 10px)' }}
        >
          <HexColorPicker color={color} onChange={onChange} />
        </div>
      )}
    </div>
  )
}

export default ColorSwatchPicker
